import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { removeFromStorage } from "../helpers";
import { RootState } from "../app/store";
import { STORAGE_KEYS } from "../constants/storageKeys";
import { User } from "../types/User";

export interface AuthState {
  user: User | null;
  token: any;
  tempToken: string | null;
  permissions?: string[] | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
  tempToken: null,
  permissions: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuth: (state) => {
      removeFromStorage(STORAGE_KEYS.token);
      state.user = null;
      state.token = null;
    },
    setCredentials: (
      state,
      action: PayloadAction<Pick<AuthState, "user" | "token">>
    ) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    temporaryToken: (
      state,
      action: PayloadAction<Pick<AuthState, "tempToken">>
    ) => {
      state.tempToken = action.payload.tempToken;
    },
    setPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload ? action.payload : null;
    },
  },
});
export const { resetAuth, setCredentials, temporaryToken, setPermissions } =
  authSlice.actions;
export const getCurrentUser = (state: RootState) => state.auth.user;
export const getPermissions = (state: RootState) => state.auth.permissions;
export const getToken = (state: RootState) => state.auth.token;
export const getTempToken = (state: RootState) => state.auth.tempToken;
export default authSlice.reducer;
